import { Moment } from 'moment';

import { ContractDetailModel, ScheduleItem } from '@falcon/app/shared/models/contract.model';
import { CompanyDetailModel } from '@falcon/app/shared/models/company.model';
import { EmployeeDetailsModel } from '@falcon/app/shared/models/employee.model';

export class EditContractState {
  contract: ContractDetailModel | null = null;
  company: CompanyDetailModel | null = null;
  employee: EmployeeDetailsModel | null = null;
  dateFrom: Moment | null = null;
  dateTo: Moment | null = null;
  pauseItems: ScheduleItem[] = [];
  scheduleItems: ScheduleItem[] = [];
}
